import cn from "classnames";
import { Shelf } from "capitalrx-components-2.0/lib/layout";

import styles from "./styles.module.scss";

export interface HeaderProps {
  logoAlignment?: "center" | "left" | "right";
  className?: string;
  noSpacing?: boolean;
}

export const Header = ({ className, noSpacing, logoAlignment = "center" }: HeaderProps) => {
  const leftAlignLogo = logoAlignment !== "center" && logoAlignment === "left";
  const rightAlignLogo = logoAlignment !== "center" && logoAlignment === "right";

  const HeaderClass = cn(styles["HeaderWrapper"], { [styles["noSpacing"]]: noSpacing }, className);

  return (
    <header className={HeaderClass}>
      <div className={styles["HeaderContent"]}>
        <Shelf>
          {rightAlignLogo && <Shelf.Spacer />}
          <div role="img" aria-label="client logo" className={styles["LogoImage"]} />
          {leftAlignLogo && <Shelf.Spacer />}
        </Shelf>
      </div>
    </header>
  );
};
